import styled from "styled-components";

export const MainContainer = styled.div`
    @media (max-width: 767px) {
            padding: 5%;
        }
`